import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UmSidebarUserComponent } from "./components/um-sidebar-user/um-sidebar-user.component";
import { UiCoreModule } from "@logex/framework/ui-core";
import { LgLocalizationModule } from "@logex/framework/lg-localization";
import { OrganizationStatusComponent } from "./components/organization-status/organization-status.component";
import { AddressPipe } from "./pipes";
import { DefinitionTagComponent } from "./components/definition-tag/definition-tag.component";
import { MultiFilterButtonComponent } from "./components/multi-filter-button/multi-filter-button.component";
import {
    AffiliationEditDialog,
    AffiliationEditDialogComponent
} from "./components/affiliation-edit-dialog/affiliation-edit-dialog.component";
import { ReactiveFormsModule } from "@angular/forms";
import { TagInputComponent } from "./components/tag-input/tag-input.component";
import { PivotSearchComponent } from "./components/pivot-search/pivot-search.component";

@NgModule({
    imports: [CommonModule, ReactiveFormsModule, LgLocalizationModule, UiCoreModule],
    declarations: [
        UmSidebarUserComponent,
        OrganizationStatusComponent,
        AddressPipe,
        DefinitionTagComponent,
        MultiFilterButtonComponent,
        AffiliationEditDialogComponent,
        TagInputComponent,
        PivotSearchComponent
    ],
    providers: [AffiliationEditDialog],
    exports: [
        UmSidebarUserComponent,
        OrganizationStatusComponent,
        AddressPipe,
        DefinitionTagComponent,
        MultiFilterButtonComponent,
        TagInputComponent,
        PivotSearchComponent
    ]
})
export class SharedModule {}
